import React from 'react';
import css from './fg.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import 'react-slideshow-image/dist/styles.css'
// @ts-ignore
import {Slide} from 'react-slideshow-image';
import img0 from "../../../assets/images/projectsImage/fgProject/0.png";
import img1 from "../../../assets/images/projectsImage/fgProject/1.png";
import img2 from "../../../assets/images/projectsImage/fgProject/2.png";
import img3 from "../../../assets/images/projectsImage/fgProject/3.png";
import img4 from "../../../assets/images/projectsImage/fgProject/4.png";
import img5 from "../../../assets/images/projectsImage/fgProject/5.png";

const slideImages = [img0, img1, img2, img3, img4, img5];

const FG: React.FC = () => (
    <div className={css.project} id="fg">
        <div className="slide-container">
            <Slide>
                {
                    slideImages.map((img, index) => (
                        <div className="each-slide" key={index}>
                            <img src={img} alt=""/>
                        </div>
                    ))
                }
            </Slide>
        </div>
        <div className={css.projectInformationContainer}>
            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>Fetch & Get</h3>
            </div>

            <div className={css.info}>
                <Chip label="2018" variant="outlined" size='small'/>
            </div>
            <div className={css.infoSmallScreen}>
                <Chip label="2018" variant="outlined" size='small'/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>It is a simple fetch & get application realized using c language, allows the
                users to find files and search for text.</p>

            <div className={css.learnMoreLink}>
                <p>Source Code: <a className={css.link}
                                   href='https://github.com/adhess/FetchGet'
                                   rel="noopener noreferrer"
                                   target="_blank">https://github.com/adhess/FetchGet</a>
                </p>
            </div>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords}>
                <Tooltip title="SDL">
                    <Chip label="SDL" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="C language">
                    <Chip label="C language" color="primary" variant="outlined" size='small'/>
                </Tooltip>
            </div>

        </div>
    </div>
);

export default FG;
